// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"9a550405","402":"c9ab87c1","405":"647aca67","534":"c6200060","648":"d9d2407c"}[chunkId] + ".chunk.css";
};